import colorsOptions from '../../fundamentals/colors-styles/constants'

import {
  TaskStatusOpen,
  TaskStatusDone,
  TaskStatusReject,
  TaskStatusOpenOverdue,
  TaskStatusClosed,
  TaskStatusInactive
} from '../../atoms/icons/task-preview'

const taskPreviewActionButtonsOptions = {
  CLOSE: 'Close',
  MARKASDONE: 'MarkAsDone',
  MARKASUNDONE: 'MarkAsUndone',
  DEACTIVATE: 'Deactivate',
  REOPEN: 'Reopen',
  REJECT: 'Reject',
  REASSIGN: 'Reassign'
}

const taskPreviewTextActionOptions = {
  [taskPreviewActionButtonsOptions.CLOSE]: 'close',
  [taskPreviewActionButtonsOptions.MARKASDONE]: 'done',
  [taskPreviewActionButtonsOptions.DEACTIVATE]: 'deactivate',
  [taskPreviewActionButtonsOptions.REOPEN]: 'taskAction_Reopen',
  [taskPreviewActionButtonsOptions.REJECT]: 'taskAction_Reject',
  [taskPreviewActionButtonsOptions.REASSIGN]: 'taskAction_Reassign'
}

const taskPreviewTaskStatusOptions = {
  OPEN: 'Open',
  OVERDUE: 'Overdue',
  DONE: 'Done',
  REJECTED: 'Rejected',
  CLOSED: 'Closed',
  INACTIVE: 'Inactive'
}

const taskPreviewStyleVariantOptions = {
  [taskPreviewTaskStatusOptions.OPEN]: {
    color: colorsOptions.greys['grey-100'],
    backgroundColor: colorsOptions.greys.white,
    borderColor: colorsOptions.greys['grey-20'],
    icon: <TaskStatusOpen />
  },
  [taskPreviewTaskStatusOptions.OVERDUE]: {
    color: colorsOptions.greys['grey-100'],
    colorDate: colorsOptions.semantics.danger['error-50'],
    backgroundColor: colorsOptions.greys.white,
    borderColor: colorsOptions.greys['grey-20'],
    icon: <TaskStatusOpenOverdue />
  },
  [taskPreviewTaskStatusOptions.DONE]: {
    color: colorsOptions.semantics.success.strong,
    colorContent: colorsOptions.greys['grey-70'],
    colorDate: colorsOptions.greys['grey-70'],
    backgroundColor: colorsOptions.semantics.success.pale,
    borderColor: colorsOptions.semantics.success.pale,
    borderBottomColor: colorsOptions.semantics.success.strong,
    icon: <TaskStatusDone />
  },
  [taskPreviewTaskStatusOptions.REJECTED]: {
    color: colorsOptions.semantics.danger['error-60'],
    colorContent: colorsOptions.greys['grey-70'],
    colorDate: colorsOptions.greys['grey-70'],
    backgroundColor: colorsOptions.semantics.danger['error-10'],
    borderColor: colorsOptions.semantics.danger['error-10'],
    borderBottomColor: colorsOptions.semantics.danger['error-60'],
    icon: <TaskStatusReject />,
    dueDateColor: ''
  },
  [taskPreviewTaskStatusOptions.CLOSED]: {
    color: colorsOptions.semantics.info.strong,
    colorContent: colorsOptions.greys['grey-70'],
    colorDate: colorsOptions.greys['grey-70'],
    backgroundColor: colorsOptions.semantics.info.pale,
    borderColor: colorsOptions.semantics.info.pale,
    borderBottomColor: colorsOptions.semantics.info.strong,
    icon: <TaskStatusClosed />
  },
  [taskPreviewTaskStatusOptions.INACTIVE]: {
    color: colorsOptions.greys['grey-40'],
    colorContent: colorsOptions.greys['grey-50'],
    colorDate: colorsOptions.greys['grey-50'],
    backgroundColor: colorsOptions.greys['grey-10'],
    background: `repeating-linear-gradient(45deg, ${colorsOptions.greys.white}, ${colorsOptions.greys.white}, 8px, ${colorsOptions.greys['grey-10']}, 8px, ${colorsOptions.greys['grey-10']} 16px)`,
    borderColor: 'transparent',
    icon: <TaskStatusInactive />
  }
}

const taskPreviewDefaultUserProfile = `
    <svg height="32" width="32" fill="none" viewBox="0 0 43 42" xmlns="http://www.w3.org/2000/svg" class="sc-kyDlHK bMmqin"><path d="M21.4019 41.0005C32.4476 41.0005 41.4019 32.0462 41.4019 21.0005C41.4019 9.95479 32.4476 1.00049 21.4019 1.00049C10.3562 1.00049 1.40192 9.95479 1.40192 21.0005C1.40192 32.0462 10.3562 41.0005 21.4019 41.0005Z" stroke="#141A21" stroke-width="2"></path><path d="M21.1543 19.9272C24.3097 19.9272 26.8676 17.3692 26.8676 14.2138C26.8676 11.0584 24.3097 8.50049 21.1543 8.50049C17.9989 8.50049 15.441 11.0584 15.441 14.2138C15.441 17.3692 17.9989 19.9272 21.1543 19.9272Z" stroke="#141A21" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></path><path d="M9.97412 32.2731C10.2905 30.0427 11.2054 27.9395 12.621 26.187C14.0366 24.4345 15.9004 23.0982 18.0145 22.3198L18.0576 22.3431C18.5388 22.5889 19.0451 22.7823 19.5676 22.9198C19.621 22.9198 19.6775 22.9431 19.7275 22.9564C19.9409 23.0064 20.151 23.0431 20.3643 23.0731C20.4377 23.0731 20.5043 23.0964 20.5743 23.1031C20.8454 23.1343 21.118 23.151 21.391 23.1532C21.6594 23.151 21.9275 23.1343 22.1942 23.1031L22.3911 23.0798C22.647 23.0455 22.9005 22.9965 23.1508 22.9331C23.4008 22.8665 23.6477 22.7864 23.8877 22.6998L24.0708 22.6331C24.2741 22.5465 24.4809 22.4565 24.6742 22.3565C24.7003 22.3429 24.7271 22.3307 24.7544 22.3198C26.8739 23.1396 28.7375 24.5076 30.1548 26.284C31.5721 28.0603 32.492 30.1812 32.8208 32.4298" stroke="#141A21" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></path></svg>
`

export {
  taskPreviewActionButtonsOptions,
  taskPreviewTextActionOptions,
  taskPreviewTaskStatusOptions,
  taskPreviewStyleVariantOptions,
  taskPreviewDefaultUserProfile
}
